import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TarefaService} from "../../../modules/trabalho/services/tarefa-service";
import {TarefaDetalhes} from "../../../modules/trabalho/models/tarefa-detalhes";
import {AtribuiTarefa} from "../../../modules/trabalho/models/atribui-tarefa";
import {StatusTarefa} from "../../../modules/trabalho/enums/status-tarefa";
import {ToastrService} from "ngx-toastr";
import {NovoComentario} from "../../models/novo-comentario";
import {UsuarioService} from "../../../modules/auth/services/usuario-service";
import {ListaSolicitante} from "../../../modules/cadastro/models/lista-solicitante";
import {ListaUsuario} from "../../../modules/auth/models/lista-usuario";

@Component({
  selector: 'app-detalhes-tarefas',
  standalone: false,
  templateUrl: './detalhes-tarefas.component.html',
  styleUrl: './detalhes-tarefas.component.css'
})
export class DetalhesTarefasComponent {
  @Input() showModal = false;
  @Output() fecharModalPai = new EventEmitter<void>();
  @Output() atualizarListaPai = new EventEmitter<void>();
  tarefa = new TarefaDetalhes();
  comentario = '';
  responsavelId: number;
  usuarios= new ListaUsuario();
  usuarioSelecionado = 0;

  isTaskOverdue(): boolean {
    return this.tarefa.atrasada;
  }

  getStatusDescription(status: number): string {
    switch (status) {
      case StatusTarefa.Planejamento:
        return 'Planejamento';
      case StatusTarefa.Afazer:
        return 'A fazer';
      case StatusTarefa.EmAndamento:
        return 'Em Andamento';
      case StatusTarefa.Validacao:
        return 'Validação';
      case StatusTarefa.Fechada:
        return 'Fechada';
      case StatusTarefa.Desativado:
        return 'Desativado';
      default:
        return '';
    }
  }

  constructor(private tarefaService: TarefaService,
              private usuarioService: UsuarioService,
              private toastr: ToastrService) {
    this.preencherUsuarios();
  }

  buscarTarefaPorId(id: number) {
    this.tarefaService.buscarPorId(id).subscribe(response => {
      if (response.sucesso) {
        this.tarefa = response.dados;
        this.usuarioSelecionado = this.tarefa.responsavelId;
      }
    });
  }

  fecharModal() {
    this.showModal = false;
    this.fecharModalPai.emit();
    this.tarefa = new TarefaDetalhes();
  }

  onBackgroundClick(event: Event): void {
    this.fecharModal();
  }

  buscarIniciais(nome: string) {
    const palavras = nome.trim().split(" ");
    const iniciais = palavras.map(palavra => palavra.charAt(0).toUpperCase());
    return iniciais.join("");
  }

  enviarComentario() {
    let novoComentario = new NovoComentario();
    novoComentario.comentario = this.comentario;
    novoComentario.tarefaId = this.tarefa.id;

    this.tarefaService.adicionarComentario(novoComentario).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success("Comentário adicionado com sucesso");
        this.buscarTarefaPorId(this.tarefa.id);
        this.comentario = '';
      } else {
        this.toastr.error("Erro ao adicionar comentário " + response.errors[0].mensagem);
      }
    }, () => {
      this.toastr.error("Erro ao adicionar comentário");
    });
  }

  alterarResponsavel() {
    let atribuir = new AtribuiTarefa();
    atribuir.id = this.tarefa.id;
    atribuir.responsavelId = this.usuarioSelecionado;
    this.tarefaService.atribuirTarefa(atribuir).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success("Tarefa atribuida com sucesso");
        this.buscarTarefaPorId(this.tarefa.id);
        this.atualizarListaPai.emit();
      }
    }, () => {
      this.toastr.error("Erro ao atribuir tarefa");
    });
  }

  iniciarTarefa() {
    let atribuir = new AtribuiTarefa();
    atribuir.id = this.tarefa.id;
    atribuir.status = StatusTarefa.EmAndamento;
    this.tarefaService.alterarStatus(atribuir).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success("Tarefa iniciada com sucesso");
        this.buscarTarefaPorId(this.tarefa.id);
        this.atualizarListaPai.emit();
      } else {
        this.toastr.error("Erro ao iniciar tarefa " + response.errors[0].mensagem);
      }
    }, () => {
      this.toastr.error("Erro ao iniciar tarefa");
    });
  }

  enviarValidacao() {
    let atribuir = new AtribuiTarefa();
    atribuir.id = this.tarefa.id;
    atribuir.status = StatusTarefa.Validacao;
    this.tarefaService.alterarStatus(atribuir).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success("Tarefa enviada para validação com sucesso");
        this.buscarTarefaPorId(this.tarefa.id);
        this.atualizarListaPai.emit();
      } else {
        this.toastr.error("Erro ao enviar para validação tarefa " + response.errors[0].mensagem);
      }
    }, () => {
      this.toastr.error("Erro ao enviar para validação tarefa");
    });
  }

  finalizarTarefa() {
    let atribuir = new AtribuiTarefa();
    atribuir.id = this.tarefa.id;
    atribuir.status = StatusTarefa.Fechada;
    this.tarefaService.alterarStatus(atribuir).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success("Tarefa finalizada com sucesso");
        this.buscarTarefaPorId(this.tarefa.id);
        this.atualizarListaPai.emit();
      } else {
        this.toastr.error("Erro ao finalizar tarefa " + response.errors[0].mensagem);
      }

    }, () => {
      this.toastr.error("Erro ao finalizar tarefa");
    });
  }

  private preencherUsuarios(){
    this.usuarioService.selecionarLista().subscribe(response => {
      if(response.sucesso){
        this.usuarios = response.dados;
      }
    });
  }
}
